export default __webpack_public_path__ + "static/media/judge4.7df41023.svg";